import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { get_band_load_all as _get_band_load_all, getStatistics as _getStatistics } from "../../services/rate/rateS";
import { get_bandwidth_stat_all as _get_bandwidth_stat_all, get_device_model_stat as _get_device_model_stat, get_device_stat as _get_device_stat, get_link_list as _get_link_list, get_link_stat as _get_link_stat, get_company_list as _get_company_list, get_device_list, get_speed_rule as _get_speed_rule, update_speed_rule as _update_speed_rule, update_company_url, get_company_url, create_company_contract as _create_company_contract, get_contract_list as _get_contract_list, update_contract as _update_contract, all_company_update } from "../../services/Company/companyS";
import { get_shrink, update_shrink } from "../../services/CI/CI1201S";
import { update_company, get_os_version as _get_os_version, update_os_version as _update_os_version, update_wan_domain, get_wan_domain as _get_wan_domain, get_organization_tree as _get_organization_tree, get_pop_path_list as _get_pop_path_list, get_reverse as _get_reverse, get_intranet_ip_pool as _get_intranet_ip_pool, update_intranet_ip_pool as _update_intranet_ip_pool, get_export as _get_export, update_export as _update_export } from "../../services/BI/BI0001S";
import { get_bandwidth_stat, get_agency_stat } from "../../services/CI/CI0801S";
import { get_company_contact as _get_company_contact, create_company_contact as _create_company_contact, update_company_contact as _update_company_contact, delete_company_contact as _delete_company_contact, delete_contract as _delete_contract } from "../../services/CI/CI1001S";
import { BossMessage } from "../../components/Common/BossMessages";
import { statusListMap } from "../../utils/commonUtilFunc";
import { get_company_keyword as _get_company_keyword, get_keyword_group as _get_keyword_group, update_company_keyword } from "../../services/MI/MI0403S";
export default {
  namespace: "bi0001Info",
  state: {
    companyListHeader: [],
    companyList: [],
    band_stat: [],
    device_model_stat: [],
    steps_beta_flow: [],
    dataSource: [],
    contractList: [],
    bandwidthStat: {},
    bandwidthTotal: 0,
    deviceStat: [],
    agencyStat: [],
    nodeData: [],
    linkDataInit: [],
    linkDataOnline: [],
    linkDataOffline: [],
    linkSum: 0,
    deviceSum: 0,
    agencySum: 0,
    companyInfo: [],
    contactList: [],
    link_stat: [],
    device_stat: [],
    deviceData: [],
    total: 0,
    // 子组件setupModal
    speedRule: [{}],
    ifShrink: 0,
    logo: "",
    versionList: [],
    domainInfo: {},
    url: "",
    bossHeaderChooseCompany: '',
    keywordGroupList: [],
    companyKeywordInfo: [{}],
    organizationStructuresList: [],
    popPathsList: [],
    popPathTotal: 0,
    popPathsReverseList: [],
    popPathsReverseTotal: 0,
    popPathsReverseListNew: [],
    popPathsReverseTotalNew: 0,
    intranet_ip_pool: ''
  },
  effects: {
    get_os_version: function get_os_version(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(_get_os_version, payload);
            case 2:
              backData = _context.sent;
              _context.next = 5;
              return put({
                type: "update",
                payload: {
                  versionList: backData.result
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    update_os_version: function update_os_version(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_update_os_version, payload);
            case 2:
              backData = _context2.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    getDeviceList: function getDeviceList(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(get_device_list, payload);
            case 2:
              backData = _context3.sent;
              _context3.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceData: backData.result,
                  total: backData.total
                }
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    getCompanyList: function getCompanyList(_ref7, _ref8) {
      var payload = _ref7.payload,
        callback = _ref7.callback;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData, companyListHeader, key;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context4.sent;
              companyListHeader = [];
              for (key in backData.result) {
                companyListHeader.push(_objectSpread({}, backData.result[key], {
                  name: backData.result[key].company,
                  id: backData.result[key].id,
                  company_abbr: backData.result[key].company_abbr,
                  is_new: String(backData.result[key].is_new) ? backData.result[key].is_new.toString() : ''
                }));
              }
              _context4.next = 7;
              return put({
                type: "update",
                payload: {
                  companyListHeader: companyListHeader || "" // bossHeaderChooseCompany:''
                }
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback(companyListHeader);
              }
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    //获取头像信息
    getLogo: function getLogo(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData, logo;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context5.sent;
              logo = [];
              logo = backData.result[0].logo;
              _context5.next = 7;
              return put({
                type: "update",
                payload: {
                  logo: logo
                }
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    get_device_stat: function get_device_stat(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData, device_stat, key;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_get_device_stat, payload);
            case 2:
              backData = _context6.sent;
              device_stat = [];
              _context6.t0 = _regeneratorRuntime().keys(backData);
            case 5:
              if ((_context6.t1 = _context6.t0()).done) {
                _context6.next = 19;
                break;
              }
              key = _context6.t1.value;
              _context6.t2 = key;
              _context6.next = _context6.t2 === "INIT" ? 10 : _context6.t2 === "ONLINE" ? 12 : _context6.t2 === "OFFLINE" ? 14 : 16;
              break;
            case 10:
              device_stat.push({
                name: "未激活",
                value: backData[key],
                color: statusListMap('INIT').color
              });
              return _context6.abrupt("break", 17);
            case 12:
              device_stat.push({
                name: "在线",
                value: backData[key],
                color: statusListMap('ONLINE').color
              });
              return _context6.abrupt("break", 17);
            case 14:
              device_stat.push({
                name: "离线",
                value: backData[key],
                color: statusListMap('OFFLINE').color
              });
              return _context6.abrupt("break", 17);
            case 16:
              return _context6.abrupt("break", 17);
            case 17:
              _context6.next = 5;
              break;
            case 19:
              if (device_stat.length === 0) {
                device_stat.push({
                  name: "暂无数据",
                  value: 1,
                  color: statusListMap('INIT').color
                });
              }
              _context6.next = 22;
              return put({
                type: "update",
                payload: {
                  device_stat: device_stat
                }
              });
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    get_link_stat: function get_link_stat(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData, link_stat, key;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_get_link_stat, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData = _context7.sent;
              link_stat = [];
              _context7.t0 = _regeneratorRuntime().keys(backData);
            case 5:
              if ((_context7.t1 = _context7.t0()).done) {
                _context7.next = 19;
                break;
              }
              key = _context7.t1.value;
              _context7.t2 = key;
              _context7.next = _context7.t2 === "INIT" ? 10 : _context7.t2 === "ONLINE" ? 12 : _context7.t2 === "OFFLINE" ? 14 : 16;
              break;
            case 10:
              link_stat.push({
                name: "未激活",
                value: backData[key],
                color: statusListMap('INIT').color
              });
              return _context7.abrupt("break", 17);
            case 12:
              link_stat.push({
                name: "在线",
                value: backData[key],
                color: statusListMap('ONLINE').color
              });
              return _context7.abrupt("break", 17);
            case 14:
              link_stat.push({
                name: "离线",
                value: backData[key],
                color: statusListMap('OFFLINE').color
              });
              return _context7.abrupt("break", 17);
            case 16:
              return _context7.abrupt("break", 17);
            case 17:
              _context7.next = 5;
              break;
            case 19:
              if (link_stat.length === 0) {
                link_stat.push({
                  name: "暂无数据",
                  value: 1,
                  color: statusListMap('INIT').color
                });
              }
              _context7.next = 22;
              return put({
                type: "update",
                payload: {
                  link_stat: link_stat
                }
              });
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    create_company_contract: function create_company_contract(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData, contractData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_create_company_contract, payload);
            case 2:
              backData = _context8.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
              _context8.next = 6;
              return call(_get_contract_list, {
                company_id: payload.company_id
              });
            case 6:
              contractData = _context8.sent;
              _context8.next = 9;
              return put({
                type: "update",
                payload: {
                  contractList: contractData.result
                }
              });
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    create_company_contact: function create_company_contact(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_create_company_contact, payload.update);
            case 2:
              backData = _context9.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
              _context9.next = 6;
              return call(_get_company_contact, payload.init);
            case 6:
              backData1 = _context9.sent;
              _context9.next = 9;
              return put({
                type: "update",
                payload: {
                  contactList: backData1.result
                }
              });
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    delete_contract: function delete_contract(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(_delete_contract, {
                id: payload.id
              });
            case 2:
              backData = _context10.sent;
              if (!backData.success) {
                _context10.next = 12;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context10.next = 7;
              return call(_get_contract_list, {
                company_id: payload.company_id
              });
            case 7:
              backData1 = _context10.sent;
              _context10.next = 10;
              return put({
                type: "update",
                payload: {
                  contractList: backData1.result
                }
              });
            case 10:
              _context10.next = 13;
              break;
            case 12:
              BossMessage(false, "Delete failed:" + backData.result);
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    update_company_contact: function update_company_contact(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return call(_update_company_contact, payload.update);
            case 2:
              backData = _context11.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
              _context11.next = 6;
              return call(_get_company_contact, payload.init);
            case 6:
              backData1 = _context11.sent;
              _context11.next = 9;
              return put({
                type: "update",
                payload: {
                  contactList: backData1.result
                }
              });
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    delete_company_contact: function delete_company_contact(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData, backData1;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_delete_company_contact, payload["delete"]);
            case 2:
              backData = _context12.sent;
              if (backData.success) {
                BossMessage(true, "Successfully deleted");
              } else {
                BossMessage(false, "Delete failed:" + backData.result);
              }
              _context12.next = 6;
              return call(_get_company_contact, payload.init);
            case 6:
              backData1 = _context12.sent;
              _context12.next = 9;
              return put({
                type: "update",
                payload: {
                  contactList: backData1.result
                }
              });
            case 9:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    update_contract: function update_contract(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData, contractData;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_update_contract, payload);
            case 2:
              backData = _context13.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
              _context13.next = 6;
              return call(_get_contract_list, {
                company_id: payload.company_id
              });
            case 6:
              contractData = _context13.sent;
              _context13.next = 9;
              return put({
                type: "update",
                payload: {
                  contractList: contractData.result
                }
              });
            case 9:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    get_company_list: function get_company_list(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context14.sent;
              _context14.next = 5;
              return put({
                type: "update",
                payload: {
                  companyInfo: backData.result[0] || {}
                }
              });
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    get_company_contact: function get_company_contact(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_get_company_contact, payload);
            case 2:
              backData = _context15.sent;
              if (!backData.result) {
                _context15.next = 6;
                break;
              }
              _context15.next = 6;
              return put({
                type: "update",
                payload: {
                  contactList: backData.result
                }
              });
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    get_contract_list: function get_contract_list(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_get_contract_list, payload);
            case 2:
              backData = _context16.sent;
              _context16.next = 5;
              return put({
                type: "update",
                payload: {
                  contractList: backData.result
                }
              });
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    //链路峰值负载率
    get_band_load_all: function get_band_load_all(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData, load_stat;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_get_band_load_all, payload);
            case 2:
              backData = _context17.sent;
              load_stat = [];
              load_stat.push({
                '0': backData.stat['0']
              });
              load_stat.push({
                '0-20': backData.stat['0-20']
              });
              load_stat.push({
                '20-40': backData.stat['20-40']
              });
              load_stat.push({
                '40-60': backData.stat['40-60']
              });
              load_stat.push({
                '60-80': backData.stat['60-80']
              });
              load_stat.push({
                '80-100': backData.stat['80-100']
              });
              _context17.next = 12;
              return put({
                type: "update",
                payload: {
                  companyList: load_stat
                }
              });
            case 12:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    //链路带宽
    get_bandwidth_stat_all: function get_bandwidth_stat_all(_ref35, _ref36) {
      var payload = _ref35.payload;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData, band_stat;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_get_bandwidth_stat_all, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData = _context18.sent;
              band_stat = [];
              band_stat.push({
                '0-10': backData['<10']
              });
              band_stat.push({
                '10-50': backData['10-50']
              });
              band_stat.push({
                '50-100': backData['50-100']
              });
              band_stat.push({
                '>=100': backData['>=100']
              });
              _context18.next = 10;
              return put({
                type: "update",
                payload: {
                  band_stat: band_stat
                }
              });
            case 10:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    //设备型号
    get_device_model_stat: function get_device_model_stat(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData, deviceModelStat, key, temp;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_get_device_model_stat, payload);
            case 2:
              backData = _context19.sent;
              deviceModelStat = [];
              for (key in backData) {
                temp = {
                  name: "",
                  value: 0
                };
                temp.name = key;
                temp.value = backData[key];
                deviceModelStat.push(temp);
              }
              _context19.next = 7;
              return put({
                type: "update",
                payload: {
                  device_model_stat: deviceModelStat
                }
              });
            case 7:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    //获取设备流量排行
    getStatistics: function getStatistics(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData, steps_beta_flow, key, temp;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_getStatistics, payload);
            case 2:
              backData = _context20.sent;
              steps_beta_flow = [];
              if (backData.msg === "ok" || backData.retcode === 0) {
                for (key in backData.data) {
                  temp = {
                    key: "",
                    value: 0
                  };
                  temp.key = backData.data[key].agency_name;
                  temp.value = Number((backData.data[key].flow / 1024 / 1024).toFixed(2)); // temp.value = backData.data[key].flow;
                  steps_beta_flow.push(temp);
                }
              }
              _context20.next = 7;
              return put({
                type: "update",
                payload: {
                  steps_beta_flow: steps_beta_flow
                }
              });
            case 7:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    get_stat: function get_stat(_ref41, _ref42) {
      var payload = _ref41.payload;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var backData1, backData4, pieData4, agencySum, key;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(get_bandwidth_stat, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData1 = _context21.sent;
              _context21.next = 5;
              return call(get_agency_stat, payload);
            case 5:
              backData4 = _context21.sent;
              pieData4 = {
                data: [],
                legend: []
              };
              agencySum = 0;
              _context21.t0 = _regeneratorRuntime().keys(backData4);
            case 9:
              if ((_context21.t1 = _context21.t0()).done) {
                _context21.next = 25;
                break;
              }
              key = _context21.t1.value;
              _context21.t2 = key;
              _context21.next = _context21.t2 === "STEP" ? 14 : _context21.t2 === "CSTEP" ? 18 : 22;
              break;
            case 14:
              pieData4.data.push({
                value: backData4[key],
                name: "边缘节点"
              });
              pieData4.legend.push("Edge nodes");
              agencySum += backData4[key];
              return _context21.abrupt("break", 23);
            case 18:
              pieData4.data.push({
                value: backData4[key],
                name: "中心节点"
              });
              pieData4.legend.push("Central node");
              agencySum += backData4[key];
              return _context21.abrupt("break", 23);
            case 22:
              return _context21.abrupt("break", 23);
            case 23:
              _context21.next = 9;
              break;
            case 25:
              _context21.next = 27;
              return put({
                type: "update",
                payload: {
                  bandwidthStat: backData1,
                  bandwidthTotal: (backData1["国内组网"] || 0) + (backData1["全球组网"] || 0) + (backData1["全球SaaS加速"] || 0) + (backData1["国内SaaS加速"] || 0),
                  agencyStat: pieData4,
                  agencySum: agencySum
                }
              });
            case 27:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    get_link_list: function get_link_list(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context22.sent;
              _context22.next = 5;
              return put({
                type: 'update',
                payload: {
                  dataSource: backData.result
                }
              });
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    },
    get_wan_domain: function get_wan_domain(_ref45, _ref46) {
      var payload = _ref45.payload;
      var call = _ref46.call,
        put = _ref46.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return call(_get_wan_domain, payload);
            case 2:
              backData = _context23.sent;
              _context23.next = 5;
              return put({
                type: 'update',
                payload: {
                  domainInfo: backData.result[0]
                }
              });
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })();
    },
    //更换头像
    // 子组建setupModal
    update_speed_rule: function update_speed_rule(_ref47, _ref48) {
      var payload = _ref47.payload;
      var call = _ref48.call,
        put = _ref48.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var backData, backData2;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return call(_update_speed_rule, payload.list);
            case 2:
              backData = _context24.sent;
              if (backData.message === "success") {
                BossMessage(true, "Successfully saved");
              } else {
                BossMessage(false, "Save failed:" + backData.result);
              }
              _context24.next = 6;
              return call(update_shrink, payload.shrink);
            case 6:
              _context24.next = 8;
              return call(update_company, payload.logo);
            case 8:
              _context24.next = 10;
              return call(update_company, payload.version);
            case 10:
              _context24.next = 12;
              return call(update_wan_domain, payload.domain);
            case 12:
              _context24.next = 14;
              return call(update_company_url, payload.url);
            case 14:
              _context24.next = 16;
              return call(update_company_keyword, payload.keywordgroup);
            case 16:
              _context24.next = 18;
              return call(all_company_update, {
                company_id: payload.list.company_id
              });
            case 18:
              _context24.next = 20;
              return call(_get_company_list, {
                company_id: payload.list.company_id
              });
            case 20:
              backData2 = _context24.sent;
              _context24.next = 23;
              return put({
                type: "update",
                payload: {
                  companyInfo: backData2.result[0] || {}
                }
              });
            case 23:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      })();
    },
    get_speed_rule: function get_speed_rule(_ref49, _ref50) {
      var payload = _ref49.payload;
      var call = _ref50.call,
        put = _ref50.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var backData, shrinkData, company_url, speedRule, key;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return call(_get_speed_rule, payload);
            case 2:
              backData = _context25.sent;
              _context25.next = 5;
              return call(get_shrink, payload);
            case 5:
              shrinkData = _context25.sent;
              _context25.next = 8;
              return call(get_company_url, payload);
            case 8:
              company_url = _context25.sent;
              speedRule = {
                oversea: false,
                overseaRule: "",
                domestic: false,
                ifShrink: false
              };
              speedRule.ifShrink = shrinkData.result.enable_activity === true;
              for (key in backData.result) {
                if (backData.result[key].type === "oversea") {
                  speedRule.oversea = true;
                  speedRule.overseaRule = backData.result[key].rule;
                } else if (backData.result[key].type === "domestic") {
                  speedRule.domestic = true;
                }
              }
              _context25.next = 14;
              return put({
                type: "update",
                payload: {
                  speedRule: backData.result.length === 0 ? [{}] : backData.result,
                  // 是否默认选中只能压缩
                  ifShrink: shrinkData.result.is_active,
                  url: company_url.result
                }
              });
            case 14:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      })();
    },
    setBossHeaderChooseValue: function setBossHeaderChooseValue(_ref51, _ref52) {
      var payload = _ref51.payload;
      var call = _ref52.call,
        put = _ref52.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return put({
                type: "update",
                payload: {
                  bossHeaderChooseCompany: payload.company_id
                }
              });
            case 2:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      })();
    },
    get_company_keyword: function get_company_keyword(_ref53, _ref54) {
      var payload = _ref53.payload;
      var call = _ref54.call,
        put = _ref54.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return call(_get_company_keyword, payload);
            case 2:
              backData = _context27.sent;
              _context27.next = 5;
              return put({
                type: 'update',
                payload: {
                  companyKeywordInfo: backData.data && backData.data.list && backData.data.list.length !== 0 ? backData.data.list : [{}]
                }
              });
            case 5:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      })();
    },
    get_keyword_group: function get_keyword_group(_ref55, _ref56) {
      var payload = _ref55.payload;
      var call = _ref56.call,
        put = _ref56.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return call(_get_keyword_group, payload);
            case 2:
              backData = _context28.sent;
              _context28.next = 5;
              return put({
                type: "update",
                payload: {
                  keywordGroupList: backData.data.list
                }
              });
            case 5:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      })();
    },
    get_organization_tree: function get_organization_tree(_ref57, _ref58) {
      var payload = _ref57.payload,
        callback = _ref57.callback;
      var call = _ref58.call,
        put = _ref58.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return call(_get_organization_tree, payload);
            case 2:
              backData = _context29.sent;
              data = backData.result && Array.isArray(backData.result) ? backData.result : [];
              if (callback && typeof callback === 'function') {
                callback(data);
              }
              _context29.next = 7;
              return put({
                type: "update",
                payload: {
                  organizationStructuresList: data
                }
              });
            case 7:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      })();
    },
    get_pop_path_list: function get_pop_path_list(_ref59, _ref60) {
      var payload = _ref59.payload;
      var call = _ref60.call,
        put = _ref60.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return call(_get_pop_path_list, payload);
            case 2:
              backData = _context30.sent;
              data = backData.result && backData.result.list && Array.isArray(backData.result.list) ? backData.result.list : [];
              _context30.next = 6;
              return put({
                type: "update",
                payload: {
                  popPathsList: data,
                  popPathTotal: backData.result && backData.result.total ? backData.result.total : 0
                }
              });
            case 6:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      })();
    },
    get_reverse: function get_reverse(_ref61, _ref62) {
      var payload = _ref61.payload;
      var call = _ref62.call,
        put = _ref62.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return call(_get_reverse, payload);
            case 2:
              backData = _context31.sent;
              data = backData.result && backData.result.list && Array.isArray(backData.result.list) ? backData.result.list : [];
              if (!(payload.platform === '3.0')) {
                _context31.next = 9;
                break;
              }
              _context31.next = 7;
              return put({
                type: "update",
                payload: {
                  popPathsReverseListNew: data,
                  popPathsReverseTotalNew: backData.result.total
                }
              });
            case 7:
              _context31.next = 11;
              break;
            case 9:
              _context31.next = 11;
              return put({
                type: "update",
                payload: {
                  popPathsReverseList: data,
                  popPathsReverseTotal: backData.result.total
                }
              });
            case 11:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      })();
    },
    get_intranet_ip_pool: function get_intranet_ip_pool(_ref63, _ref64) {
      var payload = _ref63.payload;
      var call = _ref64.call,
        put = _ref64.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return call(_get_intranet_ip_pool, payload);
            case 2:
              backData = _context32.sent;
              _context32.next = 5;
              return put({
                type: "update",
                payload: {
                  intranet_ip_pool: backData.data && backData.data.intranet_ip_pool && Array.isArray(backData.data.intranet_ip_pool) ? backData.data.intranet_ip_pool.join(',') : ''
                }
              });
            case 5:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      })();
    },
    update_intranet_ip_pool: function update_intranet_ip_pool(_ref65, _ref66) {
      var payload = _ref65.payload;
      var call = _ref66.call,
        put = _ref66.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return call(_update_intranet_ip_pool, payload.update);
            case 2:
              backData = _context33.sent;
              if (!(backData.retcode === 0)) {
                _context33.next = 9;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context33.next = 7;
              return put({
                type: "get_intranet_ip_pool",
                payload: {
                  company_id: payload.update.company_id
                }
              });
            case 7:
              _context33.next = 10;
              break;
            case 9:
              BossMessage(false, "Editing failed:" + backData.msg);
            case 10:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      })();
    },
    get_export: function get_export(_ref67, _ref68) {
      var payload = _ref67.payload;
      var call = _ref68.call,
        put = _ref68.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return call(_get_export, payload);
            case 2:
              backData = _context34.sent;
              _context34.next = 5;
              return put({
                type: "update",
                payload: {
                  enable_export_switch: backData.data ? backData.data.enable_export_switch : ''
                }
              });
            case 5:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      })();
    },
    update_export: function update_export(_ref69, _ref70) {
      var payload = _ref69.payload;
      var call = _ref70.call,
        put = _ref70.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return call(_update_export, payload.update);
            case 2:
              backData = _context35.sent;
              if (!(backData.retcode === 0)) {
                _context35.next = 9;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context35.next = 7;
              return put({
                type: "get_export",
                payload: {
                  company_id: payload.update.company_id
                }
              });
            case 7:
              _context35.next = 10;
              break;
            case 9:
              BossMessage(false, "Editing failed:" + backData.msg);
            case 10:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};